/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';
import { Switch, Route } from 'react-router';
import { createFragmentContainer, graphql } from 'react-relay';

import NavBar from './NavBar';
import Channels from './Channels';
import Home from './Home';
import Team from './Team';
import Profile from './Profile';
import Subscribe from './Subscribe';
import CreateChannel from './CreateChannel';
import ChannelView from './ChannelView';
import FinishSetup from './FinishSetup';
import ChannelCallbackGraphiQLContainer from './ChannelCallbackGraphiql';
import TeamCallbackGraphiQLContainer from './TeamCallbackGraphiql';
import Graphiql from './Graphiql';
import DeviceSetup from './device_setup/DeviceSetup';

import MessageSent from '../subscriptions/MessageSent';
import ReplySent from '../subscriptions/ReplySent';
import { STRIPEKEY } from '../const';

const drawerWidth = 240;

class Main extends React.Component {
  constructor(props) {
    super(props);
    this.drawerToggle = this.drawerToggle.bind(this);
    this.drawerClose = this.drawerClose.bind(this);
    this.state = {
      foo: 'bar',
      mobileOpen: false,
    };
  }

  drawerToggle() {
    return this.setState({
      mobileOpen: !this.state.mobileOpen,
    });
  }

  drawerClose() {
    return this.setState({
      mobileOpen: false,
    });
  }

  componentDidMount() {
    this.dispose2 = ReplySent.subscribe(this.props.viewer);
    this.dispose = MessageSent.subscribe(
      this.props.viewer.id,
      this.props.viewer.id,
    );
    // Preload stripe
    window.Stripe(STRIPEKEY);
  }

  componentWillUnmount() {
    if (this.dispose != null) {
      this.dispose.dispose();
    }
    if (this.dispose2 != null) this.dispose2.dispose();
  }

  render() {
    return (
      <div className="flex h-full w-full">
        <Switch>
          <Route
            path="/channel/create"
            render={routeProps => {
              return (
                <div className="w-full flex flex-col">
                  <NavBar drawerToggle={this.drawerToggle} />
                  <Channels
                    drawerToggle={this.drawerToggle}
                    drawerClose={this.drawerClose}
                    mobileOpen={this.state.mobileOpen}
                    viewer={this.props.viewer}
                  />
                  <div className="relative p-4 md:ml-[240px] md:p-8 flex flex-col flex-grow bg-gray-50 min-h-screen">
                    <CreateChannel viewer={this.props.viewer} {...routeProps} />
                  </div>
                </div>
              );
            }}
          />
          <Route
            path="/graphiql"
            render={channelProps => {
              return <Graphiql viewer={this.props.viewer} />;
            }}
          />
          <Route
            path="/"
            render={moreProps => {
              return (
                <div className="w-full flex flex-col">
                  <NavBar drawerToggle={this.drawerToggle} />
                  <Channels
                    drawerToggle={this.drawerToggle}
                    drawerClose={this.drawerClose}
                    mobileOpen={this.state.mobileOpen}
                    viewer={this.props.viewer}
                  />
                  <div className="relative p-4 md:ml-[240px] md:p-8 flex flex-col flex-grow bg-gray-50 min-h-screen">
                    <Switch>
                      <Route
                        path="/subscribe"
                        render={channelProps => {
                          return (
                            <Subscribe
                              viewer={this.props.viewer}
                              {...channelProps}
                            />
                          );
                        }}
                      />
                      <Route
                        path="/channels/:channel_id"
                        render={channelProps => {
                          return <ChannelView {...channelProps} />;
                        }}
                      />
                      <Route
                        path="/finish_setup"
                        render={channelProps => {
                          return <FinishSetup viewer={this.props.viewer} />;
                        }}
                      />
                      <Route
                        path="/device_setup"
                        render={channelProps => {
                          return <DeviceSetup viewer={this.props.viewer} />;
                        }}
                      />
                      <Route
                        path="/channel_callback/:channel_id"
                        render={channelProps => {
                          return (
                            <ChannelCallbackGraphiQLContainer
                              viewer={this.props.viewer}
                            />
                          );
                        }}
                      />
                      <Route
                        path="/profile"
                        render={tokenProps => {
                          return <Profile viewer={this.props.viewer} />;
                        }}
                      />
                      <Route
                        path="/team"
                        render={tokenProps => {
                          return <Team />;
                        }}
                      />
                      <Route
                        path="/team_callback"
                        render={channelProps => {
                          return (
                            <TeamCallbackGraphiQLContainer
                              viewer={this.props.viewer}
                            />
                          );
                        }}
                      />
                      <Route
                        path="/"
                        render={tokenProps => {
                          return <Home viewer={this.props.viewer} />;
                        }}
                      />
                    </Switch>
                  </div>
                </div>
              );
            }}
          />
        </Switch>
      </div>
    );
  }
}

Main = createFragmentContainer(Main, {
  viewer: graphql`
    fragment Main_viewer on User {
      id
      ...Channels_viewer
      ...Graphiql_viewer
      ...Home_viewer
      ...Profile_viewer
      ...Subscribe_viewer
      ...FinishSetup_viewer
    }
  `,
});

export default Main;
